import React, { useEffect, useState } from "react";
import "./App.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../redux/hooks";
import PopupWithImage from "../PopupWithImage/PopupWithImage";
import { authorization, checkAuth } from "../../redux/Reducers/userSlice";
import { getTextOnPage } from "../../redux/Reducers/editorSlice";
import { RouterComponent } from "../../router";
import { ScrollUp } from "../ScrollUp";
import { normalizeInternalPath } from "../../utils/seo";
import { hasSessionHint } from "../../utils/authSession";

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { hash, pathname, search } = useLocation();
  const navigate = useNavigate();
  const [authReady, setAuthReady] = useState(() => !hasSessionHint());

  useEffect(() => {
    const normalizedPathname = normalizeInternalPath(pathname);

    if (normalizedPathname !== pathname) {
      navigate({ hash, pathname: normalizedPathname, search }, { replace: true });
    }
  }, [hash, navigate, pathname, search]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (hasSessionHint()) {
      dispatch(checkAuth({ navigate, pathname })).finally(() => setAuthReady(true));
    } else {
      dispatch(authorization(false));
      setAuthReady(true);
    }
  }, []);

  useEffect(() => {
    dispatch(getTextOnPage());
  }, []);

  return (
    <div className="page">
      {authReady && <RouterComponent />}
      <PopupWithImage />
      <ScrollUp />
    </div>
  );
};

export default App;
